
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
// import { useStore } from "vuex";
import * as Yup from "yup";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

// import Swal from "sweetalert2";
import { useRouter } from "vue-router";
import user from "@/user/composables/useUser";

export default defineComponent({
  name: "password-reset",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const router = useRouter();

    const { restoreCode, verifyCode } = user();

    const emailForm = ref({
      correo_electronico: "",
    });

    //Create form validation object
    const forgotPassword = Yup.object().shape({
      email: Yup.string()
        .email("Debe ser un correo institucional válido")
        .required("Correo institucional requerido.")
        .label("Email"),
    });

    const onSubmitForgotPassword = async () => {
      // console.log('enviando', emailForm.value)
      const formulario = {
        correo_electronico: emailForm.value.correo_electronico,
      };
      const data = await restoreCode(emailForm.value);
      // console.log('enviado', data)
      if (data.data == undefined) {
        // console.log('correo no existente', data.message.response.data)
        Swal.fire({
          icon: "error",
          title: data.message.response.data,
          confirmButtonText: "Aceptar",
          // text: "Compruebe que el correo electronico este bien escrito.",
          // footer: '<a href="">Why do I have this issue?</a>',
        });
      } else {
        // console.log('enviaremos el codigo para comprobacion')
        Swal.fire({
          title:
            "Introduzca el código enviado a su Número de Contacto o Correo Electronico.",
          // text: "Introduzca el codigo enviado a su Correo Electronico.",
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Comprobar",
          showLoaderOnConfirm: true,
          preConfirm: (codigoVerificacion) => {
            // console.log(codigoVerificacion)
            let sendData = {
              codigo: codigoVerificacion,
              correo_electronico: emailForm.value.correo_electronico,
            };
            return verifyCode(sendData)
              .then((response) => {
                // console.log(response)
                if (!response.data) {
                  // console.log('botamos alerta error en verificacion', response.message)
                  throw new Error("Credenciales incorrectas");
                  // throw new Error(response.message)
                }
              })
              .catch((error) => {
                Swal.showValidationMessage(`${error}`);
              });
          },
          /*
          preConfirm: (login) => {
            return fetch(`//api.github.com/users/${login}`)
              .then(response => {
                if (!response.ok) {
                  throw new Error(response.statusText)
                }
                return response.json()
              })
              .catch(error => {
                Swal.showValidationMessage(
                  `Error de verificación: ${error}`
                )
              })
          },
          */
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "Contraseña modificada",
              text: "Se le envio su nueva contraseña a su correo electronico y número de contacto",
              // title: `${result.value.login}'s avatar`,
              // imageUrl: result.value.avatar_url
            }).then(function () {
              router.push({ name: "sign-in" });
            });
          }
        });
      }
    };

    return {
      emailForm,
      forgotPassword,
      onSubmitForgotPassword,
    };

    // const submitButton = ref<HTMLButtonElement | null>(null);

    //Form submit function
    /*
    const onSubmitForgotPassword = (values) => {
      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      // Activate loading indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.FORGOT_PASSWORD, values)
          .then(() => {
            Swal.fire({
              text: "Password reset email have been successfully sent!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          })
          .catch(() => {
            const [error] = Object.keys(store.getters.getErrors);
            // Alert then login failed
            Swal.fire({
              text: store.getters.getErrors[error],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });

        submitButton.value?.removeAttribute("data-kt-indicator");
        // eslint-disable-next-line
        submitButton.value!.disabled = false;
      }, 2000);
    };
    

    return {
      onSubmitForgotPassword,
      forgotPassword,
      submitButton,
    };
    */
  },
});
